import { useState, useContext } from 'react';
import Rating from 'react-rating-stars-component';
import { submitReview } from '../../services/ChallengeReviewService';
import { usePermissions } from '../../contexts/PermissionContext';
import { AuthContext } from '../../contexts/AuthContext';

export default function ChallengeReview({ challenge, reviews }) {
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({ setup: 0, difficulty: 0, overall: 0, comment: '' });
  const { permissions } = usePermissions();
  const { user: currentUser } = useContext(AuthContext);
  const userHasReviewed = reviews.some((r) => r.user_id === currentUser.user_id);
  console.log("[ChallengeReview:handleSubmit] has reviewed:", currentUser.user_id, userHasReviewed);
  
  const handleInputChange = (field) => (value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async () => {
    try {
      await submitReview(challenge.id, {
        challenge_id: challenge.id,
        setup_rating: formData.setup,
        difficulty_rating: formData.difficulty,
        overall_rating: formData.overall,
        comment: formData.comment,
      });

      setShowModal(false);
      window.location.reload();
    } catch (error) {
      console.error("Error submitting review:", error);
    }
  };

return (
    <div id="reviews" className="a-section">
        <h2
            className="a-size-base bold-weight-text"
            style={{ fontSize: '18px', marginBottom: '10px' }}
        >
            Challenge Reviews
        </h2>
        <div className="reviews">
            {reviews.length === 0 ? (
                <>
                    <p>No reviews yet for this challenge.</p>
                    {permissions.add_edit_challenge_reviews && (
                    <button
                        className="add-challenge-button"
                        style={{ marginTop: '10px' }}
                        onClick={() => setShowModal(true)}
                    >
                        Write a Review
                    </button>
                    )}
                </>
            ) : (
                <>
                    <ul className="review-list">
                        {reviews.map((review) => (
                            <li
                                key={review.id}
                                className="review-item"
                                style={{
                                    border: '1px solid #ddd',
                                    padding: '10px',
                                    borderRadius: '4px',
                                    marginBottom: '10px',
                                }}
                            >
                                <div
                                    className="review-header"
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        marginBottom: '6px',
                                    }}
                                >
                                    <span className="review-user">User #{review.user_id}</span>
                                    <span className="review-date">
                                        {new Date(review.created_at).toLocaleDateString()}
                                    </span>
                                </div>
                                <div className="review-ratings">
                                    <div>
                                        <strong>Overall:</strong>{' '}
                                        <Rating value={review.overall_rating} edit={false} size={20} />
                                    </div>
                                    <div>
                                        <strong>Ease of Setup:</strong>
                                        {review.setup_rating} / 5
                                    </div>
                                    <div>
                                        <strong>Challenge Difficulty:</strong>
                                        {review.difficulty_rating} / 5
                                    </div>
                                </div>
                                {review.comment && (
                                    <p
                                        className="review-comment"
                                        style={{ marginTop: '8px', fontStyle: 'italic' }}
                                    >
                                        "{review.comment}"
                                    </p>
                                )}
                            </li>
                        ))}
                    </ul>
                    

                    {!userHasReviewed && permissions.add_edit_challenge_reviews && (
                    <button
                        className="add-challenge-button"
                        style={{ marginTop: '10px' }}
                        onClick={() => setShowModal(true)}
                    >
                        Write a Review
                    </button>
                    )}
                </>
            )}
        </div>

        {showModal && (
            <div className="modal-overlay">
                <div className="modal-content">
                    <h3>Submit Your Review</h3>
                    <div>
                        <label>
                            <strong>Overall:</strong>
                        </label>
                        <Rating
                            value={formData.overall}
                            onChange={handleInputChange('overall')}
                            size={22}
                        />
                    </div>

                    <div>
                        <label>
                            <strong>Ease of Setup:</strong>
                        </label>
                        <input
                            type="number"
                            min="1"
                            max="5"
                            value={formData.setup}
                            onChange={(e) =>
                                handleInputChange('setup')(parseInt(e.target.value))
                            }
                            style={{ width: '50px', marginLeft: '10px' }}
                        />
                    </div>
                    <div>
                        <label>
                            <strong>Challenge Difficulty:</strong>
                        </label>
                        <input
                            type="number"
                            min="1"
                            max="5"
                            value={formData.difficulty}
                            onChange={(e) =>
                                handleInputChange('difficulty')(parseInt(e.target.value))
                            }
                            style={{ width: '50px', marginLeft: '10px' }}
                        />
                    </div>
                    <div>
                        <label>
                            <strong>Comments:</strong>
                        </label>
                        <textarea
                            value={formData.comment}
                            onChange={(e) =>
                                setFormData((prev) => ({ ...prev, comment: e.target.value }))
                            }
                            rows={4}
                            style={{ width: '100%', marginTop: '8px' }}
                        />
                    </div>
                    <div className="modal-buttons">
                        <button onClick={() => setShowModal(false)}>Cancel</button>
                        <button
                            style={{ backgroundColor: '#2563eb', color: 'white' }}
                            onClick={handleSubmit}
                        >
                            Submit
                        </button>
                    </div>
                </div>
            </div>
        )}
    </div>
);
}
